export const getAllCombos = (state) => {
  if (state.combos.response) {
    return state.combos.response.data;
  } else {
    return null;
  }
};
